<div>
    <div class="modal-header customBlueHeader">
        <p class="modal-title">Submit Samples</p>
        <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>

    <div class="modal-body customModalBody">
                <div class="row">
                <div class="col-md-4" ><label>Pickup Boy From</label></div>
                <div class="col-md-1" ><label>:</label></div>
                <div class="col-md-2" ><input type="radio" [formControl]="pickupboyRadioOptions"  value="callhealth">CallHealth</div>
                <div class="col-md-2" ><input type="radio" [formControl]="pickupboyRadioOptions" 
                 value="vendor">Vendor</div>
                </div><br>
                <div class="row">
                <div class="col-md-4" ><label>Pickup Boy Name</label></div>
                <div class="col-md-1" ><label>:</label></div>
                <div class="col-md-2" ><input type="textbox" [formControl]="pickup_boy_name"  style="height:30px;font-size:14pt;"size="25"></div>
                </div><br>
                <div class="row">
                <div class="col-md-4" ><label>Pickup Boy Mobile No</label></div>
                <div class="col-md-1" ><label>:</label></div>
                <div class="col-md-2" ><input type="textbox" [formControl]="pickup_boy_mobile" style="height:30px;font-size:14pt;"size="25"></div>
                </div><br>
                <div class="row">
                <div class="col-md-4" ></div>
                <div class="col-md-1" ></div>
                <div class="col-md-3" >
                <button type="button" class="btn btn-primary" (click)="sendOTPforsamplesubmission('send_otp');">Send OTP</button>
                </div>
                <div class="col-md-2" >
                <button type="button" class="btn btn-primary"  Style="width:85px;" (click)="sendOTPforsamplesubmission('resend');">Resend</button>
                </div>
                </div>
                <div class="row martop20">
                <div class="col-md-4" ></div>
                <div class="col-md-1" ></div>
                <div class="col-md-2" >
                <input type="textbox" [formControl]="pickup_boyOTP" placeholder="enter otp">
                </div>
                <div class="col-md-1" ></div>
                <div class="col-md-4" >
                <button type="button" class="btn btn-success" (click)="sendOTPforsamplesubmission('verify_otp');">Verify OTP</button>
                </div>
                </div>
        
    </div>
      <div class="modal-footer customModalFooter customModalFooter">
            <button type="submit" class="btn info_btn" (click)="sampleSubmission()">Submit Samples</button>
            <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>
      </div>
</div>